import React, { useEffect } from "react";
import Grid from "@mui/material/Grid2";
import Navigation from "../../Components/Navigation";
import Footer from "../../Components/Footer";
import { Button } from '@mui/material';
import { Link } from '@mui/material';
import Typography from '@mui/material/Typography';
import ContactRibbon from "../../Components/ContactRibbon";
import HeroAlt from "../../Components/HeroAlt";

import Newsletter1 from '../../Images/FF-Newsletter-issue-1.jpg';
import Newsletter2 from '../../Images/FF-Newsletter-issue2-test.jpg';
//import Newsletter3 from '../../Images/FF-Newsletter-issue-3.jpg';
import Newsletter3 from '../../Images/FF-Newsletter-issue-3-edit.jpg';
import Newsletter4 from '../../Images/FF-Newsletter-issue-4.jpg';
import Newsletter5 from '../../Images/FF-Newsletter-issue-5.jpg';
import Newsletter6 from '../../Images/FF-Newsletter-issue-6.jpg';
import Newsletter7 from '../../Images/FF-Newsletter-issue-7.jpg';


export default function Newsletters() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Newsletters";
  }, []);

  return (
    <main>
      <Navigation />
      <HeroAlt title="Stay Informed with the Forward Focus Newsletter" />

      <section padding="2% 2%">
        <Grid container size={12} justifyContent="center" padding="2% 0" spacing={2} backgroundColor="#f4f4f4">
          {/*CURRENT MEETINGS SECTION */}
          <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
         
            <Grid size={12} padding="1% 0">
              <p>
                The Forward Focus Newsletter keeps Eastern Alachua County residents updated on our latest initiatives.
                Each issue highlights upcoming meetings, community collaborations, and updates on ongoing infrastructure
                projects and plans.
                Want to stay in the loop? Join our mailing list by emailing your contact information to:
               <span><a href="mailto:forwardfocus@alachuacounty.us."> forwardfocus@alachuacounty.us</a></span> 
              </p>
            </Grid>
            <Grid container size={12} spacing={4} justifyContent='flex-start'>
            <Grid container item size={{ xs: 12, md: 6, lg: 4 }} className='newsletter-wrapper'>
              <Grid container flexDirection='column'>
                  <Typography variant="h5"  textAlign='center' gutterBottom><strong>Issue #7</strong></Typography>
                  <Link target='blank' href='https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-7.pdf'>
                  <img className="newsletter-img" src={Newsletter7} alt="Newsletter 7" />
                  </Link>
                  <Button
                        variant="outlined"
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-7.pdf"
                        target="_blank"
                      >
                    View Newsletter
                      </Button>
                </Grid>
              </Grid>
            <Grid container item size={{ xs: 12, md: 6, lg: 4 }} className='newsletter-wrapper'>
              <Grid container flexDirection='column'>
                  <Typography variant="h5"  textAlign='center' gutterBottom><strong>Issue #6</strong></Typography>
                  <Link target='blank' href='https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-6.pdf'>
                  <img className="newsletter-img" src={Newsletter6} alt="Newsletter 6" />
                  </Link>
                  <Button
                        variant="outlined"
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-6.pdf"
                        target="_blank"
                      >
                    View Newsletter
                      </Button>
                </Grid>
              </Grid>
              <Grid container item size={{ xs: 12, md: 6, lg: 4 }} className='newsletter-wrapper'>
              <Grid container flexDirection='column'>
                  <Typography variant="h5"  textAlign='center' gutterBottom><strong>Issue #5</strong></Typography>
                  <Link target='blank'   href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-5.pdf">
                  <img className="newsletter-img" src={Newsletter5} alt="Newsletter 5" />
                  </Link>
                  <Button
                        variant="outlined"
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-5.pdf"
                        target="_blank"
                      >
                    View Newsletter
                      </Button>
                </Grid>
              </Grid>
            <Grid container item size={{ xs: 12, md: 6, lg: 4 }} className='newsletter-wrapper' flexWrap='wrap'>
              <Grid container item flexDirection='column'>
                  <Typography variant="h5"  textAlign='center' gutterBottom><strong>Issue #4</strong></Typography>
                  <Link target='blank' href='https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-4.pdf'>
                  <img className="newsletter-img" src={Newsletter4} alt="Newsletter 4" />
                  </Link>
                  <Button
                        variant="outlined"
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-4.pdf"
                        target="_blank"
                      >
                    View Newsletter
                      </Button>
                </Grid>
              </Grid>
              <Grid container item size={{ xs: 12, md: 6, lg: 4 }} className='newsletter-wrapper'>
              <Grid container flexDirection='column'>
                  <Typography variant="h5"  textAlign='center' gutterBottom><strong>Issue #3</strong></Typography>
                  <Link target='blank' href='https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-3.pdf'>
                  <img className="newsletter-img" src={Newsletter3} alt="Newsletter 3" />
                  </Link>
                  <Button
                        variant="outlined"
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-3.pdf"
                        target="_blank"
                      >
                    View Newsletter
                      </Button>
                </Grid>
              </Grid>
              <Grid container item size={{ xs: 12, md: 6, lg: 4 }} className='newsletter-wrapper'>
              <Grid container flexDirection='column'>
                  <Typography variant="h5"  textAlign='center' gutterBottom><strong>Issue #2</strong></Typography>
                  <Link target='blank' href='https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-2.pdf'>
                  <img className="newsletter-img" src={Newsletter2} alt="Newsletter 2" />
                  </Link>
                  <Button
                        variant="outlined"
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-2.pdf"
                        target="_blank"
                      >
                    View Newsletter
                      </Button>
                </Grid>
              </Grid>
              <Grid container item size={{ xs: 12, md: 6, lg: 4 }} className='newsletter-wrapper'>
                <Grid container flexDirection='column' xs={12}>
                  <Typography variant="h5"  textAlign='center' gutterBottom><strong>Issue #1</strong></Typography>
                  <Link target='blank' href='https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-1.pdf'>
                  <img className="newsletter-img" src={Newsletter1} alt="Newsletter 2" />
                  </Link>
                  <Button
                        variant="outlined"
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button" 
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-1.pdf"
                        target="_blank"
                      >
                       View Newsletter
                      </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </section>

      <section padding="2% 2%"></section>

      {/* CODE FOR THE CONTACT US RIBBON */}
      <section className="contact-container">
        <ContactRibbon />
      </section>

      <Footer />
    </main>
  );
}